import React from "react";
import EmailLogo from "@/app/assets/icons/email-logo";
import Info from "@/app/assets/icons/info";
import { Input } from "@/stories/input/input";

interface DetermineEmailAuthProps {
    email: string;
    setEmail: React.Dispatch<React.SetStateAction<string>>;
    name: string;
    setName: React.Dispatch<React.SetStateAction<string>>;
    emailError: string | null;
    nameError: string | null;
    setEmailError: (type: string) => void;
    setNameError: (type: string) => void;
    hasBtnDisabled: boolean;
    handleEmailVerify: () => void;
}

const EmailInput: React.FC<DetermineEmailAuthProps> = ({
    email,
    setEmail,
    // name,
    // setName,
    // nameError,
    emailError,
    // setNameError,
    setEmailError,
    hasBtnDisabled,
    handleEmailVerify,
}) => {
    const triggerEnterKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // console.log("ee ", e, hasBtnDisabled, String(e.key)?.toLowerCase());
        if (!hasBtnDisabled && String(e.key)?.toLowerCase() === "enter") {
            handleEmailVerify();
        }
    };

    const isIOS = typeof navigator !== "undefined" && /iP(hone|od|ad)/.test(navigator.userAgent);

    return (
        <div className="flex w-full flex-col gap-2">
            {/* Name Input */}
            {/* <div
                className={`flex h-14 w-full items-center justify-start gap-1 rounded-[12px] border p-s7 transition-colors duration-500 ${
                    nameError ? "border-error-600" : "border-neutral-50"
                }`}
            >
                <Input
                    placeholder="Enter your name"
                    showIcon={false}
                    className="border-b-0"
                    value={name}
                    onChange={(e) => {
                        const val = e.target.value;
                        setNameError("");
                        setName(val);
                    }}
                    onKeyUp={(e) => {
                        triggerEnterKeyUp(e);
                    }}
                    style={{
                        ...(isIOS ? { fontSize: "16px", lineHeight: "1.2" } : {})
                      }}
                />
            </div>
            <div
                className={`flex transform items-center gap-2 transition-all duration-500 ${
                    nameError ? "translate-y-0 opacity-100" : "-translate-y-2 opacity-0"
                }`}
            >
                <Info width="12" height="12" className="text-error-600" />
                <p className="text-sm text-error-600">{nameError}</p>
            </div> */}

            {/* Email Input */}
            <div
                className={`flex h-14 w-full items-center justify-start gap-1 rounded-[12px] border p-s7 transition-colors duration-500 ${
                    emailError ? "border-error-600" : "border-neutral-50"
                }`}
            >
                <EmailLogo />
                <Input
                    placeholder="Enter your email"
                    showIcon={false}
                    className="border-b-0"
                    value={email}
                    onChange={(e) => {
                        const val = e.target.value;
                        setEmailError("");
                        setEmail(val);
                    }}
                    onBlur={(e) => {
                        setEmail(e.target.value.trim()); // clean it up when user leaves the field
                    }}
                    onKeyUp={(e) => {
                        triggerEnterKeyUp(e);
                    }}
                    style={{
                        ...(isIOS ? { fontSize: "16px", lineHeight: "1.2" } : {})
                      }}
                />
            </div>
            <div
                className={`flex transform items-center gap-2 transition-all duration-500 ${
                    emailError ? "translate-y-0 opacity-100" : "-translate-y-2 opacity-0"
                }`}
            >
                <Info width="12" height="12" className="text-error-600" />
                <p className="text-sm text-error-600">{emailError}</p>
            </div>
        </div>
    );
};

export default EmailInput;
